import { request } from '../../../../lib/request';
import { SUSHI_DATA_API_HOST } from 'sushi/config/subgraph';
import { graphql } from '../../graphql';
export const PortfolioWalletQuery = graphql(`
  query PortfolioWallet($id: ID!) {
    portfolioWallet(id: $id) {
      totalUSD
      amountUSD24Change
      percentageChange24h
      tokens {
        id
        chain
        chainId
        name
        symbol
        decimals
        logoUrl
        protocolId
        price
        price24hChange
        isVerified
        isCore
        isWallet
        timeAt
        amount
        rawAmount
        amountUSD
      }
    }
  }
`);
export async function getPortfolioWallet(variables, options) {
    const url = `${SUSHI_DATA_API_HOST}/graphql`;
    const result = await request({ url, document: PortfolioWalletQuery, variables }, options);
    if (result) {
        return result.portfolioWallet;
    }
    throw new Error('No portfolio wallet');
}
